import * as THREE from "three";
import debug from "debug";
import { USE_GEOMETRY_EDGES } from "../PostProcessing/config.js";

const log = debug("app:edges");

export default class EdgeManager {
  private scene: THREE.Scene;
  private eventHub: any;
  private edgesEnabled = false;
  private is3DModeActive = false;

  constructor(experience: any) {
    this.scene = experience.scene;
    this.eventHub = experience.eventHub;

    this.eventHub.on("shadedWithEdges", (state: { enabled: boolean }) => {
      this.edgesEnabled = state.enabled;
      this.updateVisibility();
    });

    this.eventHub.on("3d-switch", (state: { enabled: boolean }) => {
      this.is3DModeActive = state.enabled;
      this.updateVisibility();
    });

    // Initial state comes from shadedWithEdges and 3d-switch events (emitted by UIEventTracker)
  }

  /** Only visible when BOTH edges checkbox is on AND 3D mode is active. Hidden when Sobel is used. */
  private updateVisibility(): void {
    const show =
      USE_GEOMETRY_EDGES && this.edgesEnabled && this.is3DModeActive;
    this.toggleEdges(show);
  }

  private toggleEdges(showEdges: boolean): void {
    let count = 0;
    this.scene.traverse((object) => {
      if (object instanceof THREE.Mesh) {
        const edges = object.children.find(
          (child) => child.name === "ObjectEdge"
        );
        if (edges) {
          edges.visible = showEdges;
          count++;
        }
      }
    });
    log(`Geometry edges ${showEdges ? "ON" : "OFF"} (${count} meshes)`);
  }
}
